import { useTranslations } from "next-intl";

/** Veltric's own legal notice. One constant: the link is not configurable. */
export const PLATFORM_IMPRINT_URL = "https://veltric.app/impressum";

/** Veltric's own privacy policy. One constant: the link is not configurable. */
export const PLATFORM_PRIVACY_URL = "https://veltric.app/datenschutz";

/**
 * "Impressum Veltric · Datenschutz Veltric" — the PLATFORM's legal notice and
 * privacy policy, on every portal screen a guest can land on.
 *
 * Deliberately independent of everything the operator configures: not part of
 * the operator footer (which only mounts when they set a contact or a legal
 * URL), not behind `showPoweredBy` (a white-label switch for the brand line,
 * not for who runs the servers). The portal is served by Veltric whatever the
 * operator's settings say, so neither link has an off state.
 *
 * Each carries its own test id and never reuses `portal-imprint-link` /
 * `portal-privacy-link`: those are the OPERATOR's documents, and a test or a
 * guard that cannot tell the two apart would accept either as proof of the
 * other.
 */
export function PlatformImprintLink({ style }: { style?: React.CSSProperties | undefined }) {
  const t = useTranslations();
  return (
    <p className="mt-4 text-center text-[11px]" style={style}>
      <a
        href={PLATFORM_IMPRINT_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
        data-testid="portal-platform-imprint-link"
      >
        {t("platformImprintLink")}
      </a>
      <span aria-hidden="true"> · </span>
      <a
        href={PLATFORM_PRIVACY_URL}
        target="_blank"
        rel="noopener noreferrer"
        className="hover:underline"
        data-testid="portal-platform-privacy-link"
      >
        {t("platformPrivacyLink")}
      </a>
    </p>
  );
}
